module.exports = __webpack_public_path__ + "img/type-02.851fb9c1.svg";